module.exports = __webpack_public_path__ + "img/download.e1c3417a.svg";